const STORAGE_KEY = 'containerWiderView';
const LABEL_WIDE = 'Wide';
const LABEL_NARROW = 'Compact';

const ICON_CLASSES = {
  on: 'fa-toggle-on',
  off: 'fa-toggle-off',
} as const;

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('toggle-width-btn');
  if (!btn) return;

  const containers = document.querySelectorAll('#content');
  containers.forEach((container) => container.classList.add('no-transition'));

  const container = btn.closest('.width-switch-container');
  const label = container ? container.querySelector('.label') : undefined;
  const icon = btn.querySelector('i');

  const saved = localStorage.getItem(STORAGE_KEY);
  const isWiderView = saved !== 'false';

  btn.setAttribute('data-toggled', isWiderView.toString());
  containers.forEach((container) => {
    container.classList.toggle('wider-view', isWiderView);
  });

  if (icon) {
    icon.classList.remove(isWiderView ? ICON_CLASSES.off : ICON_CLASSES.on);
    icon.classList.add(isWiderView ? ICON_CLASSES.on : ICON_CLASSES.off);
  }

  if (label) {
    label.textContent = isWiderView ? LABEL_WIDE : LABEL_NARROW;
  }

  btn.addEventListener('click', function () {
    const current = btn.getAttribute('data-toggled') === 'true';
    const newState = !current;
    btn.setAttribute('data-toggled', newState.toString());
    containers.forEach((container) => container.classList.remove('no-transition'));
    containers.forEach((container) => {
      container.classList.toggle('wider-view', newState);
    });

    if (icon) {
      icon.classList.remove(newState ? ICON_CLASSES.off : ICON_CLASSES.on);
      icon.classList.add(newState ? ICON_CLASSES.on : ICON_CLASSES.off);
    }
    if (label) {
      label.textContent = newState ? LABEL_WIDE : LABEL_NARROW;
    }
    localStorage.setItem(STORAGE_KEY, newState ? 'true' : 'false');
  });
});
